'use client'
import {
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'

import {
  IframeProps,
  NormalizedSection,
  OpeningTitleProps,
  ParagraphProps,
  TitleProps,
} from '@/types'

import { QueryParamsWrapper } from '@/components/organisms/QueryParamsWrapper'

export interface StoreLocatorIframeProps extends NormalizedSection {
  modelledContent: {
    openingTitle: OpeningTitleProps
    title: TitleProps
    paragraph: ParagraphProps
    iframe: IframeProps
  }
}

const StoreLocatorIframe = ({ modelledContent }: StoreLocatorIframeProps) => {
  const { openingTitle, title, paragraph, iframe } = modelledContent
  const { src, allow, id, scrolling, allowParameters } = iframe

  return (
    <Section className='section-store-locator-iframe'>
      <div className='section-wrapper'>
        <div className='section-intro'>
          <OpeningTitle {...openingTitle}>{openingTitle.content}</OpeningTitle>
          <div className='section-intro--content'>
            <Title
              {...title}
              dangerouslySetInnerHTML={{ __html: title.content || '' }}
            />
            <Paragraph
              as={'div'}
              dangerouslySetInnerHTML={{ __html: paragraph.content || '' }}
            />
          </div>
        </div>
        <div className='section-content'>
          <QueryParamsWrapper>
            {(params) => {
              let ctaLink = src
              if (allowParameters) {
                // TODO: make it generic function
                const hasUtmParams = params.has('utm_campaign')
                const linkHasParams = src ? new URL(src) : null

                const hasExistingUtmParams =
                  linkHasParams?.searchParams.has('utm_campaign')

                const queryString =
                  hasUtmParams || hasExistingUtmParams
                    ? `?${params.toString()}`
                    : ''
                ctaLink = `${src}${queryString}`.replace(/\?$/, '')
              }
              return (
                <iframe
                  title='Trova la piazza'
                  className='section-store-locator-iframe-element'
                  id={id || 'store-locator-iframe'}
                  src={ctaLink}
                  allow={allow}
                  scrolling={scrolling}
                />
              )
            }}
          </QueryParamsWrapper>
        </div>
      </div>
    </Section>
  )
}

export default StoreLocatorIframe
